import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";

const GameDurationClock = ({ timestamp, isLive, className }) => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (isLive) {
      setIsRunning(true);
    } else if (!isLive) {
      setIsRunning(false);
    }
  }, [isLive]);

  useEffect(() => {
    if (!isRunning) return;

    const interval = setInterval(() => {
      const nowUnix = Math.floor(Date.now() / 1000);
      const ts = Number(timestamp);
      if (!Number.isFinite(ts) || ts <= 0) {
        setTime(0);
        return;
      }
      const elapsed = nowUnix - ts;
      setTime(elapsed >= 0 ? elapsed : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, timestamp]);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <Typography className={className}>
      {formattedMinutes}:{formattedSeconds}
    </Typography>
  );
};

export default GameDurationClock;